import capitalizeFirstLetter from '../../../utilities/capitalizeFirstLetter';
import clsx from "clsx";
import styles from './Status.module.scss';

const Status = ({ currStatus, grid, ...props }) => {
    return (
        <div className={clsx(styles.status, styles[currStatus])} {...props}>
            <span className={clsx(styles.circle, styles[currStatus])} />
            {capitalizeFirstLetter(currStatus)}
        </div>
    );
};
export default Status;
